enum MeasurementType {
  MOUNTED_TIRE_TREAD = 'MOUNTED_TIRE_TREAD',
  STORED_TIRE_TREAD = 'STORED_TIRE_TREAD',
  BRAKE_PAD_THICKNESS = 'BRAKE_PAD_THICKNESS',
  BRAKE_DISC_THICKNESS = 'BRAKE_DISC_THICKNESS',
  BRAKE_DRUM_THICKNESS = 'BRAKE_DRUM_THICKNESS',
  BRAKE_SHOE_THICKNESS = 'BRAKE_SHOE_THICKNESS',
}

export default MeasurementType;
